/**
 * @generated SignedSource<<96b3048f0d9f71d3172ccb46aa33e56f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useRefreshShopifyTokenMutation$variables = {
  brandId: string;
};
export type useRefreshShopifyTokenMutation$data = {
  readonly refreshShopifyToken: {
    readonly accessTokenExpiresAt: any | null;
    readonly accessTokenLast4: string | null;
    readonly adminChangeUrl: string | null;
    readonly error: string;
    readonly refreshTokenExpiresAt: any | null;
    readonly refreshedAt: any | null;
    readonly state: string;
  };
};
export type useRefreshShopifyTokenMutation = {
  response: useRefreshShopifyTokenMutation$data;
  variables: useRefreshShopifyTokenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "brandId",
        "variableName": "brandId"
      }
    ],
    "concreteType": "InternShopifyTokenStatus",
    "kind": "LinkedField",
    "name": "refreshShopifyToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessTokenLast4",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessTokenExpiresAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refreshTokenExpiresAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refreshedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "adminChangeUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRefreshShopifyTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRefreshShopifyTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c67ed3570c00742b30b921f4cf898d09",
    "id": null,
    "metadata": {},
    "name": "useRefreshShopifyTokenMutation",
    "operationKind": "mutation",
    "text": "mutation useRefreshShopifyTokenMutation(\n  $brandId: ID!\n) {\n  refreshShopifyToken(brandId: $brandId) {\n    state\n    accessTokenLast4\n    accessTokenExpiresAt\n    refreshTokenExpiresAt\n    refreshedAt\n    error\n    adminChangeUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "00d4ae95918e341148777a7e02e683dc";

export default node;
